import MultipleContact from './multiple-contact';

export default MultipleContact;
